










import { Component, Mixins, Prop } from "vue-property-decorator";
import Context from "@/mixins/context";
import { IBasket } from "@/models/baskets";
import { GuestRoutes } from "@/data/enums/router";

@Component
export default class UBasketLink extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public basketId!: IBasket["id"];

  // Getters
  public get link() {
    // IF client context
    if (this.isAdmin) {
      return this.adminRouterLink(this.basketId);
    }
    return this.clientRouterLink();
  }

  // Methods
  public clientRouterLink() {
    return {
      type: "router-link",
      props: {
        to: {
          name: GuestRoutes.STORE
        }
      }
    };
  }

  public adminRouterLink(basketId) {
    return {
      type: "router-link",
      props: {
        to: {
          name: `adminOrderBasketView`,
          params: {
            basketId
          }
        }
      }
    };
  }
}
